var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#EBF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9117 27.9624C52.6343 27.7274 52.2983 27.5718 51.9395 27.5124C51.5808 27.453 51.2126 27.4919 50.8742 27.6249L27.7992 36.6874C27.3945 36.8416 27.0516 37.1246 26.8235 37.4928C26.5954 37.8609 26.4946 38.2939 26.5367 38.7249C26.5742 39.1558 26.7505 39.5629 27.0389 39.8852C27.3274 40.2075 27.7126 40.4276 28.1367 40.5124L33.9992 41.6749V48.9999C33.999 49.3962 34.1165 49.7836 34.3368 50.113C34.5571 50.4424 34.8704 50.6989 35.2367 50.8499C35.4791 50.9475 35.7378 50.9984 35.9992 50.9999C36.2619 51.0009 36.5221 50.9494 36.7646 50.8485C37.0072 50.7476 37.2272 50.5994 37.4117 50.4124L40.6617 47.1749L45.5742 51.4999C45.9369 51.8198 46.4031 51.9974 46.8867 51.9999C47.0993 52.0043 47.311 51.9705 47.5117 51.8999C47.8416 51.7956 48.1385 51.6069 48.373 51.3526C48.6076 51.0983 48.7717 50.7871 48.8492 50.4499L53.5492 29.9249C53.6313 29.5708 53.6154 29.2009 53.5031 28.8551C53.3908 28.5094 53.1863 28.2007 52.9117 27.9624ZM34.7617 39.7874L28.5367 38.5499L45.9867 31.6874L34.7617 39.7874ZM35.9992 48.9999V43.0749L39.1492 45.8499L35.9992 48.9999ZM46.8992 49.9999L36.5992 40.9374L51.4367 30.2249L46.8992 49.9999Z",
    fill: "#007AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.b6f31c8991297b361c037870a2f1eb8c.svg";
export { ForwardRef as ReactComponent };